<template>
  <div
    class="app-header"
    :class="{
      '-mt-6': !noOverlap,
    }"
  >
    <div
      :class="{
        'container shadow-md bg-white border-b-4 border-primary-200': !noOverlap,
      }"
    >
      <nav
        v-if="$slots.navigation"
        :class="{
          'app-header-tabs -mb-1': !noOverlap,
          'flex justify-center app-header-links border-b border-grey-300': noOverlap,
        }"
      >
        <slot name="navigation" />
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppHeader",
  props: {
    noOverlap: {
      type: Boolean,
      default() {
        return true;
      },
    },
  },
};
</script>

<style>
.app-header .icon-link {
  @apply text-secondary-200 inline-block;
}

.app-header-tabs,
.app-header-links {
  @apply relative;
}

.app-header-tabs:after,
.app-header-links:after {
  @apply absolute pin-t pin-r h-full w-6;
  content: "";
  background-image: linear-gradient(
    to left,
    rgba(242, 243, 244, 100),
    rgba(242, 243, 244, 0)
  );
}

.app-header-tabs ul,
.app-header-links ul {
  @apply list-reset flex relative leading-none overflow-x-auto;
}

.app-header-tabs li {
  @apply mr-8;
}

.app-header-tabs li:last-child {
  @apply pr-6;
}

@screen md {
  .app-header-tabs:after,
  .app-header-links:after {
    display: none;
  }
  .app-header-tabs li:last-child {
    @apply mr-0 pr-0;
  }
}

.app-header-tabs a,
.app-header-tabs button {
  @apply no-underline block text-black border-b-4 py-4 whitespace-no-wrap border-primary-200;
  transition: all 0.2s ease-in-out;
}

.app-header-links a,
.app-header-links button {
  @apply no-underline block text-black p-4 whitespace-no-wrap border-transparent border-b-2;
  transition: all 0.2s ease-in-out;
}

.app-header-tabs a:hover,
.app-header-tabs button:hover {
  @apply text-primary-600 border-primary-500;
}

.app-header-links a:hover,
.app-header-links button:hover {
  @apply border-grey-300;
}

.app-header-tabs a.is-active,
.app-header-tabs button.is-active {
  @apply text-primary-600 border-primary-500;
}

.app-header-links a.is-active,
.app-header-links button.is-active {
  @apply border-grey-400;
}

.app-header-tabs a.has-errors,
.app-header-tabs button.has-errors {
  @apply text-negative-200;
}

.app-header-tabs a.has-errors.is-active,
.app-header-tabs button.has-errors.is-active {
  @apply text-negative-200 border-negative-200;
}

.app-header-tabs a.tab-grading,
.app-header-tabs button.tab-grading {
  @apply text-positive-500;
}

.app-header-tabs a.tab-grading.is-active,
.app-header-tabs button.tab-grading.is-active {
  @apply border-positive-500;
}
</style>
